import React from "react";
import { is10Perfect, isAuthentic, getGradingNameFromGrade } from "../../utils/utils";

const RadiantLabel = ({
  labelLines = [],
  titleLine,
  serialNumber,
  grading,
  evaluation,
}) => {
  const isPristine = is10Perfect(grading);
  const authentic = isAuthentic(grading);

  const gradeOverall = grading.grade_overall;
  let isHalfVote = false;
  let gradeOverallToDisplay = gradeOverall;

  if (gradeOverallToDisplay?.toString().includes('.') && !authentic) {
    isHalfVote = true;
    gradeOverallToDisplay = gradeOverallToDisplay.toString().split('.')[0];
  }

  const labelImageSrc = isPristine
    ? '/images/label_pristine_front.png'
    : '/images/label_radiant_front.png';

  const resolvedEvaluation = evaluation
    || (gradeOverall != null ? getGradingNameFromGrade(gradeOverall.toString(), grading.is_10_perfect) : null);
  const caseFresh = Boolean(grading.is_case_fresh) && !authentic;
  const evaluationText = !isPristine
    ? (authentic ? 'AUTHENTIC' : (caseFresh ? 'CASE FRESH' : (resolvedEvaluation?.[1]?.toUpperCase() || '')))
    : '';
  const hasGrade = gradeOverall != null;
  // L'esito puo esistere senza voto numerico: authentic e case fresh sono alternative al grade.
  const gradeLabel = authentic ? 'A' : (caseFresh ? 'CF' : gradeOverallToDisplay);
  const showGrade = !isPristine && (hasGrade || authentic || caseFresh);

  const titleLineLength = (titleLine || '').length;
  const isTitleMultiLine = titleLineLength > 25;

  return (
    <>
      <img src={labelImageSrc} alt="" className="dco__label-image" />

      <div className="dco__label-text">
        <div className="dco__serial-col">
          {serialNumber && (
            <div className="dco__serial-number">{serialNumber}</div>
          )}
        </div>

        <div className="dco__info-col">
          <div
            className="dco__info-lines"
            style={{ height: isTitleMultiLine ? '66px' : '54px' }}
          >
            {labelLines.map((line, i) => (
              line ? (
                <div key={i} className={`dco__info-line${i === 0 ? ' dco__info-line--bold' : ''}`}>
                  {line}
                </div>
              ) : null
            ))}
          </div>
          <div
            className="dco__title-line"
            style={{ maxHeight: isTitleMultiLine ? '24px' : '12px' }}
          >
            {titleLine || ''}
          </div>
        </div>

        <div className="dco__grade-col">
          {showGrade && (
            <>
              <div className="dco__grade-value">
                {gradeLabel}
                {isHalfVote && !authentic && !caseFresh && (
                  <span
                    className="dco__grade-half"
                    style={{
                      ...(gradeOverallToDisplay === '7' ? { marginLeft: '-8px' } : {}),
                      ...(gradeOverallToDisplay === '9' ? { marginLeft: '-3px' } : {}),
                    }}
                  >
                    .5
                  </span>
                )}
              </div>
              <div className="dco__evaluation">{evaluationText}</div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default RadiantLabel;
